import API from '../../../constants/api';

export const FETCH_PATIENT_PORTAL_INTEGRATIONS = '@@patientPortalIntegration/FETCH_PATIENT_PORTAL_INTEGRATIONS';
export const FETCH_PATIENT_PORTAL_INTEGRATIONS_SUCCESS = '@@patientPortalIntegration/FETCH_PATIENT_PORTAL_INTEGRATIONS_SUCCESS';
export const FETCH_PATIENT_PORTAL_INTEGRATIONS_FAILURE = '@@patientPortalIntegration/FETCH_PATIENT_PORTAL_INTEGRATIONS_FAILURE';

export const fetchPatientPortalIntegrations = ({
    page,
    size,
    filters,
    seekParams,
    seekDirection,
}) => ({
    type: FETCH_PATIENT_PORTAL_INTEGRATIONS,
    api: API.PATIENT_PORTAL_INTEGRATION.SEEKABLE_PAGE,
    page,
    size,
    filters,
    seekParams,
    seekDirection,
});
